/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import {$applyNodeReplacement, TextNode} from 'lexical'

function convertMentionElement(domNode) {
	const textContent = domNode.textContent
	const agentId = domNode.getAttribute('data-mention-agent-id')

	if (textContent !== null) {
		const node = $createMentionNode(textContent, agentId)
		return {
			node,
		}
	}

	return null
}

export class MentionNode extends TextNode {
	__mention
	__mentionAgentId

	static getType() {
		return 'mention'
	}

	static clone(node) {
		return new MentionNode(node.__mention, node.__mentionAgentId, node.__text, node.__key)
	}
	static importJSON(serializedNode) {
		const node = $createMentionNode(serializedNode.mentionName, serializedNode.mentionAgentId)
		node.setTextContent(serializedNode.text)
		node.setFormat(serializedNode.format)
		node.setDetail(serializedNode.detail)
		node.setMode(serializedNode.mode)
		node.setStyle(serializedNode.style)
		node.setAttribute('data-mention-agent-id', serializedNode.mentionAgentId)
		return node
	}

	constructor(mentionName, mentionAgentId, text, key) {
		super(text ?? mentionName, key)
		this.__mention = mentionName
		this.__mentionAgentId = mentionAgentId
	}

	exportJSON() {
		return {
			...super.exportJSON(),
			mentionName: this.__mention,
			mentionAgentId: this.__mentionAgentId,
			type: 'mention',
		}
	}

	createDOM(config) {
		const dom = super.createDOM(config)
		//dom.style.cssText = mentionStyle;
		dom.className = 'mention'
		dom.setAttribute('data-mention-agent-id', this.__mentionAgentId)
		return dom
	}

	exportDOM() {
		const element = document.createElement('span')
		element.setAttribute('data-mention', 'true')
		element.setAttribute('data-mention-agent-id', this.__mentionAgentId)
		element.textContent = this.__text
		return {element}
	}

	static importDOM() {
		return {
			span: (domNode) => {
				if (!domNode.hasAttribute('data-mention')) {
					return null
				}
				return {
					conversion: convertMentionElement,
					priority: 1,
				}
			},
		}
	}

	isTextEntity() {
		return true
	}

	canInsertTextBefore() {
		return false
	}

	canInsertTextAfter() {
		return false
	}
}

export function $createMentionNode(mentionName, mentionAgentId) {
	const mentionNode = new MentionNode(mentionName, mentionAgentId)
	mentionNode.setMode('token').toggleDirectionless()
	return $applyNodeReplacement(mentionNode)
}

export function $isMentionNode(node) {
	return node instanceof MentionNode
}
